import { Icon, IconName, TextLink } from '@pm/ui';

// ViewResultsLink and DownloadLink share the same pt-xl container + icon-label
// layout. This component collapses the two into a single reusable CTA, varying
// only in whether the link opens externally.
export type HeroCardActionProps = {
  label: string;
  icon: IconName;
  to: string;
  external?: boolean;
};

export const HeroCardAction = ({
  label,
  icon,
  to,
  external,
}: HeroCardActionProps) => (
  <TextLink to={to} variant="primary" external={external}>
    <span className="inline-flex items-center gap-s">
      {label}
      <Icon name={icon} size="medium" />
    </span>
  </TextLink>
);
